(function () {
  var PROP_BUNDLE = '_Solinia LP bundle';
  var PROP_GIFT = '_Solinia LP gift';
  var PROP_CREAM = '_Landing page offer';
  var SOURCE = 'solinia-lp-gift-bundle';
  var SOURCE_BATCH = 'solinia-lp-gift-bundle-batch';

  function createBundleId() {
    return 'lpb_' + Date.now().toString(36) + '_' + Math.random().toString(36).slice(2, 9);
  }

  function getBundleId(item) {
    if (!item.properties) return '';
    return item.properties[PROP_BUNDLE] || '';
  }

  function isLpGift(item) {
    return Boolean(item.properties && item.properties[PROP_GIFT]);
  }

  function isLpCreamParent(item) {
    return Boolean(getBundleId(item) && item.properties && item.properties[PROP_CREAM] && !isLpGift(item));
  }

  function getBundleRemovalUpdates(cart, line) {
    var item = cart.items[line - 1];
    if (!item || !isLpCreamParent(item)) return null;

    var bundleId = getBundleId(item);
    var updates = {};
    cart.items.forEach(function (cartItem) {
      if (getBundleId(cartItem) === bundleId) updates[cartItem.key] = 0;
    });

    return Object.keys(updates).length > 1 ? updates : null;
  }

  function findOrphanedGiftLines(items) {
    var parentBundles = new Set();
    items.forEach(function (item) {
      if (isLpCreamParent(item)) parentBundles.add(getBundleId(item));
    });

    var lines = [];
    items.forEach(function (item, index) {
      if (!isLpGift(item)) return;
      var bundleId = getBundleId(item);
      if (bundleId && !parentBundles.has(bundleId)) lines.push(index + 1);
    });
    return lines;
  }

  function getSectionsForRefresh() {
    var sections = ['cart-icon-bubble'];
    if (document.getElementById('CartDrawer') || document.querySelector('cart-drawer')) {
      sections.push('cart-drawer');
    }
    var mainCartItems = document.getElementById('main-cart-items');
    if (mainCartItems && mainCartItems.dataset.id) sections.push(mainCartItems.dataset.id);
    var mainCartFooter = document.getElementById('main-cart-footer');
    if (mainCartFooter && mainCartFooter.dataset.id) sections.push(mainCartFooter.dataset.id);
    return sections;
  }

  function applyCartQuantityResponse(
    cartItems,
    line,
    quantity,
    event,
    name,
    variantId,
    eventTarget,
    parsedState,
    cartUpdateSource
  ) {
    if (typeof CartPerformance !== 'undefined') {
      CartPerformance.measure(eventTarget + ':paint-updated-sections"', function () {
        var quantityElement =
          document.getElementById('Quantity-' + line) || document.getElementById('Drawer-quantity-' + line);
        var items = document.querySelectorAll('.cart-item');

        if (parsedState.errors) {
          if (quantityElement) quantityElement.value = quantityElement.getAttribute('value');
          cartItems.updateLiveRegions(line, parsedState.errors);
          return;
        }

        cartItems.classList.toggle('is-empty', parsedState.item_count === 0);
        var cartDrawerWrapper = document.querySelector('cart-drawer');
        var cartFooter = document.getElementById('main-cart-footer');

        if (cartFooter) cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);
        if (cartDrawerWrapper) cartDrawerWrapper.classList.toggle('is-empty', parsedState.item_count === 0);

        cartItems.getSectionsToRender().forEach(function (section) {
          var container = document.getElementById(section.id);
          if (!container) return;
          var elementToReplace = container.querySelector(section.selector) || container;
          elementToReplace.innerHTML = cartItems.getSectionInnerHTML(
            parsedState.sections[section.section],
            section.selector
          );
        });

        if (quantityElement) {
          var updatedValue = parsedState.items[line - 1] ? parsedState.items[line - 1].quantity : undefined;
          var message = '';
          if (items.length === parsedState.items.length && updatedValue !== parseInt(quantityElement.value, 10)) {
            if (typeof updatedValue === 'undefined') {
              message = window.cartStrings.error;
            } else {
              message = window.cartStrings.quantityError.replace('[quantity]', updatedValue);
            }
          }
          cartItems.updateLiveRegions(line, message);
        }

        var lineItem = document.getElementById('CartItem-' + line) || document.getElementById('CartDrawer-Item-' + line);
        if (lineItem && lineItem.querySelector('[name="' + name + '"]')) {
          if (cartDrawerWrapper) {
            trapFocus(cartDrawerWrapper, lineItem.querySelector('[name="' + name + '"]'));
          } else {
            lineItem.querySelector('[name="' + name + '"]').focus();
          }
        } else if (parsedState.item_count === 0 && cartDrawerWrapper) {
          trapFocus(cartDrawerWrapper.querySelector('.drawer__inner-empty'), cartDrawerWrapper.querySelector('a'));
        } else if (document.querySelector('.cart-item') && cartDrawerWrapper) {
          trapFocus(cartDrawerWrapper, document.querySelector('.cart-item__name'));
        }
      });

      CartPerformance.measureFromEvent(eventTarget + ':user-action', event);
    } else {
      cartItems.getSectionsToRender().forEach(function (section) {
        var container = document.getElementById(section.id);
        if (!container || !parsedState.sections) return;
        var elementToReplace = container.querySelector(section.selector) || container;
        elementToReplace.innerHTML = cartItems.getSectionInnerHTML(
          parsedState.sections[section.section],
          section.selector
        );
      });
    }

    if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      publish(PUB_SUB_EVENTS.cartUpdate, {
        source: cartUpdateSource || 'cart-items',
        cartData: parsedState,
        variantId: variantId,
      });
    }
  }

  function patchCartItemsUpdateQuantity() {
    if (typeof CartItems === 'undefined' || CartItems.prototype._soliniaBundlePatched) return;

    CartItems.prototype._soliniaBundlePatched = true;
    var originalUpdateQuantity = CartItems.prototype.updateQuantity;

    CartItems.prototype.updateQuantity = function (line, quantity, event, name, variantId) {
      if (quantity !== 0) {
        return originalUpdateQuantity.call(this, line, quantity, event, name, variantId);
      }

      var cartItems = this;
      cartItems.enableLoading(line);

      var eventTarget = event.currentTarget instanceof CartRemoveButton ? 'clear' : 'change';
      var sections = cartItems.getSectionsToRender().map(function (section) {
        return section.section;
      });
      var sectionsUrl = window.location.pathname;

      return fetch('/cart.js', {
        credentials: 'same-origin',
        headers: { Accept: 'application/json' },
      })
        .then(function (response) {
          return response.json();
        })
        .then(function (cart) {
          var updates = getBundleRemovalUpdates(cart, line);
          var url = updates
            ? (window.routes && window.routes.cart_update_url) || '/cart/update.js'
            : routes.cart_change_url;
          var body = updates
            ? { updates: updates, sections: sections, sections_url: sectionsUrl }
            : { line: line, quantity: quantity, sections: sections, sections_url: sectionsUrl };

          return fetch(url, Object.assign({}, fetchConfig(), { body: JSON.stringify(body) }))
            .then(function (response) {
              return response.text();
            })
            .then(function (state) {
              var parsedState = JSON.parse(state);
              applyCartQuantityResponse(
                cartItems,
                line,
                quantity,
                event,
                name,
                variantId,
                eventTarget,
                parsedState,
                updates ? SOURCE_BATCH : 'cart-items'
              );
            });
        })
        .catch(function () {
          cartItems.querySelectorAll('.loading__spinner').forEach(function (overlay) {
            overlay.classList.add('hidden');
          });
          var errors = document.getElementById('cart-errors') || document.getElementById('CartDrawer-CartErrors');
          if (errors) errors.textContent = window.cartStrings.error;
        })
        .finally(function () {
          cartItems.disableLoading(line);
        });
    };
  }

  function renderCartSections(parsedState) {
    if (!parsedState || !parsedState.sections) return;

    if (window.SoliniaCartDrawer && typeof window.SoliniaCartDrawer.render === 'function' && parsedState.sections['cart-drawer']) {
      window.SoliniaCartDrawer.render(parsedState);
    }

    var cartItems = document.querySelector('cart-items');
    if (cartItems && typeof cartItems.getSectionsToRender === 'function') {
      cartItems.getSectionsToRender().forEach(function (section) {
        var html = parsedState.sections[section.section];
        if (!html) return;
        var container = document.getElementById(section.id);
        if (!container) return;
        var elementToReplace = container.querySelector(section.selector) || container;
        elementToReplace.innerHTML = cartItems.getSectionInnerHTML(html, section.selector);
      });
      if (typeof parsedState.item_count === 'number') {
        cartItems.classList.toggle('is-empty', parsedState.item_count === 0);
      }
    }

    var drawerItems = document.querySelector('cart-drawer-items');
    if (drawerItems && typeof drawerItems.getSectionsToRender === 'function') {
      drawerItems.getSectionsToRender().forEach(function (section) {
        var html = parsedState.sections[section.section];
        if (!html) return;
        var container = document.getElementById(section.id);
        if (!container) return;
        var elementToReplace = container.querySelector(section.selector) || container;
        elementToReplace.innerHTML = drawerItems.getSectionInnerHTML(html, section.selector);
      });
      if (typeof parsedState.item_count === 'number') {
        drawerItems.classList.toggle('is-empty', parsedState.item_count === 0);
        var cartDrawerWrapper = document.querySelector('cart-drawer');
        if (cartDrawerWrapper) cartDrawerWrapper.classList.toggle('is-empty', parsedState.item_count === 0);
      }
    }
  }

  var cleanupInProgress = false;

  function cleanupOrphanedLpGifts() {
    if (cleanupInProgress) return Promise.resolve();
    cleanupInProgress = true;

    return fetch('/cart.js', {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' },
    })
      .then(function (response) {
        return response.json();
      })
      .then(function (cart) {
        var lines = findOrphanedGiftLines(cart.items);
        if (!lines.length) return null;

        var updates = {};
        lines.forEach(function (line) {
          var item = cart.items[line - 1];
          if (item) updates[item.key] = 0;
        });
        if (!Object.keys(updates).length) return null;

        var sections = getSectionsForRefresh();
        return fetch((window.routes && window.routes.cart_update_url) || '/cart/update.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({
            updates: updates,
            sections: sections,
            sections_url: window.location.pathname,
          }),
        }).then(function (response) {
          return response.json();
        });
      })
      .then(function (parsedState) {
        if (!parsedState) return;

        renderCartSections(parsedState);
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartUpdate, { source: SOURCE, cartData: parsedState });
        }
      })
      .catch(function (error) {
        console.error('Solinia LP gift cleanup failed', error);
      })
      .finally(function () {
        cleanupInProgress = false;
      });
  }

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, function (event) {
      if (event && (event.source === SOURCE || event.source === SOURCE_BATCH)) return;
      return cleanupOrphanedLpGifts();
    });
  }

  function init() {
    patchCartItemsUpdateQuantity();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  window.SoliniaLpGiftBundle = {
    PROP_BUNDLE: PROP_BUNDLE,
    createBundleId: createBundleId,
    cleanup: cleanupOrphanedLpGifts,
  };
})();
